<template>
  <v-container fluid>
    <v-row>
      <v-col v-if="!composingmail" :cols="(admin )?2:0">
        <scelta-template v-if="admin" />
      </v-col>
      <v-col v-if="composingmail && admin" :cols="12">
        <editor-email v-model="testomail" v-on:inviocompletato="composingmail=false" @chiudi="composingmail=false">{{testomail}}</editor-email>
      </v-col>
      <v-col v-if="!composingmail" :cols="admin?10:12">
        <v-overlay :absolute="false" opacity="0.6" :value="loading" :z-index="10">
          <v-progress-circular :width="10" color="red" indeterminate :size="470">loading</v-progress-circular>
        </v-overlay>
        <v-row class="text-center">
          <v-col cols="12">
            <v-skeleton-loader :loading="loading" height="700" type="image">
              <v-carousel hide-delimiters height="700">
                <v-carousel-item
                  v-for="(item,i) in preventivo.galleria_generale"
                  :key="i"
                  :src="item.src"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                ></v-carousel-item>

                <v-col style="position: absolute; height:150px; bottom:0;">
                  <v-overlay :absolute="true" :opacity="0.5" :value="true">
                    <editor
                      :admin="admin"
                      v-model="preventivo.titolo"
                      gestiscitemplate="true"
                      @settemplate="template_to_export.nominativo=$event"
                      :intemplate="template_to_export.nominativo"
                    >
                      <h3 class="display-3 font-weight-light">{{preventivo.titolo}}</h3>
                    </editor>

                    <editor
                      :admin="admin"
                      v-model="preventivo.intro"
                      gestiscitemplate="true"
                      @settemplate="template_to_export.intro=$event"
                      :intemplate="template_to_export.intro2"
                    >
                      <h4 class="display-2 font-weight-light">{{preventivo.intro}}</h4>
                    </editor>
                  </v-overlay>
                </v-col>
              </v-carousel>

              <editor-galleria :admin="admin" v-model="preventivo.galleria_generale" />
            </v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row>
          <v-col xs12 md6>
            <v-container grid-list-xs>
              <editor
                :admin="admin"
                v-model="preventivo.testoiniziale"
                htmlenabled="true"
                gestiscitemplate="true"
                @settemplate="template_to_export.testoiniziale=$event"
                :intemplate="template_to_export.testoiniziale"
              >
                <div class="body1 font-weight-light text-left" v-html="preventivo.testoiniziale"></div>
              </editor>
            </v-container>
          </v-col>
          <v-col xs12 md6>
            <v-container v-for="(item, index) in preventivo.slogan" :key="index">
              <v-row>
                <v-card class="mx-auto" tile ma-3>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="headline mb-1">
                        {{item.titolo}}
                        <editor :admin="admin" v-model="item.titolo"></editor>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{item.sottotitolo}}
                        <editor :admin="admin" v-model="item.sottotitolo"></editor>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-card-actions></v-card-actions>
                </v-card>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12">
            <hr />
          </v-col>

          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <h3 class="display-2 font-weight-light">
                  <editor
                    :admin="admin"
                    v-model="preventivo.titolo2"
                    gestiscitemplate="true"
                    @settemplate="template_to_export.titolo=$event"
                    :intemplate="template_to_export.titolo"
                  >{{preventivo.titolo2}}</editor>
                </h3>
                <h4 class="display-1 font-weight-light">
                  <editor
                    :admin="admin"
                    v-model="preventivo.sottotitolo"
                    gestiscitemplate="true"
                    @settemplate="template_to_export.sottotitolo=$event"
                    :intemplate="template_to_export.sottotitolo"
                  >{{preventivo.sottotitolo}}</editor>
                </h4>
              </v-col>

              <v-col
                xs12
                md2
                v-for="(soluzione, index) in preventivo.soluzioni"
                :key="soluzione.id"
              >
                <v-card class="mx-auto" max-width="400">
                  <v-img class="white--text align-end" height="200px" :src="soluzione.img">
                    <v-card-title>Soluzione {{index + 1}}</v-card-title>
                  </v-img>

                  <v-card-subtitle class="pb-0"></v-card-subtitle>

                  <v-card-text class="text--primary">
                    <div class="text-left">
                      <h3 class="font-weight-light subtitle-2">ARRIVO / PARTENZA</h3>
                      <h4 class="font-weight-light">{{soluzione.dal}} fino a {{soluzione.al}}</h4>
                      <h3 class="font-weight-light subtitle-2">CATEGORIA CAMERA</h3>
                      <h4 class="font-weight-light">{{soluzione.tipologie}}</h4>
                      <h3 class="font-weight-light subtitle-2">PERSONE / TRATTAMENTO</h3>
                      <h4
                        class="font-weight-light"
                      >{{soluzione.occupancy}} / {{soluzione.trattamento}}</h4>
                    </div>

                    <div
                      class="text-uppercase headline font-weight-bold text-right"
                    >€ {{soluzione.prezzo/100}}</div>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="orange" @click="seleziona(soluzione)" text>Dettagli</v-btn>
                    <v-btn color="green" @click="conferma(soluzione)" text>Conferma</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-tabs
                  v-model="tab"
                  background-color="secondary accent-4"
                  :centered="false"
                  :grow="true"
                  :vertical="false"
                  :right="false"
                  :icons-and-text="icons"
                  show-arrows
                >
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab
                    v-for="(soluzione,i) in preventivo.soluzioni"
                    :key="soluzione.id"
                    :href="`#tab-${soluzione.id}`"
                  >
                    Soluzione {{ i+1 }}
                    <v-icon v-if="icons">mdi-phone</v-icon>
                  </v-tab>

                  <v-tab-item v-for="i in preventivo.soluzioni" :key="i.id" :value="'tab-' + i.id">
                    <v-card flat tile>
                      <!--<v-card-text>{{ text }}</v-card-text>-->
                      <soluzione :data="i" :admin="admin"></soluzione>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item,i) in preventivo.info" :key="i">
                    <v-expansion-panel-header>
                      <v-col v-if="admin" cols="1">
                        <v-btn @click="del_text(item)" class="mx-2" fab dark small color="red">
                          <v-icon dark>mdi-minus</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col>
                        <span class="font-weight-light subtitle-1">{{item.titolo}}</span>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="font-weight-light text-left">
                      <v-col v-html="item.testo"></v-col>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <v-col cols="12" v-if="admin">
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item) in testi" :key="item.id">
                    <v-expansion-panel-header>
                      <v-col cols="1">
                        <v-btn @click="add_text(item)" class="mx-2" fab dark small color="green">
                          <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col>
                        <span class="font-weight-light subtitle-1">{{item.titolo}}</span>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="font-weight-light text-left">
                      <v-col v-html="item.testo"></v-col>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-row>

        <v-footer dark padless>
          <v-card flat tile class="secondary lighten-1 white--text text-center" style="width:100%">
            <v-card-text>
              <v-btn v-for="icon in footer_icons" :key="icon" class="mx-4 white--text" icon>
                <v-icon size="24px">{{ icon }}</v-icon>
              </v-btn>
            </v-card-text>

            <v-card-text class="white--text pt-0">
              {{preventivo.footer}}
              <editor :admin="admin" v-model="preventivo.footer" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text">
              {{ new Date().getFullYear() }} —
              <strong>
                {{preventivo.nomehotel}}
                <editor :admin="admin" v-model="preventivo.nomehotel"></editor>
              </strong>
            </v-card-text>
          </v-card>
        </v-footer>


      </v-col>
              <v-speed-dial
          v-if="user.loggedIn"
          v-model="fab"
          bottom
          fixed
          left
          absolute
          :open-on-hover="false"
          transition="slide-y-transition"
          z-index="10000"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="blue darken-2" dark fab>
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <v-btn @click="setvalue()" fab dark small color="green">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn @click="admin=!admin" fab dark small color="red">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click="invia()" fab dark small color="blue">
            <v-icon>mdi-send</v-icon>
          </v-btn>
          <v-btn @click="composemail()" fab dark small color="blue">
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </v-speed-dial>
    </v-row>
  </v-container>
</template>

<script>
import Soluzione from "@/components/Soluzione.vue";
import Editor from "@/components/Editor.vue";
import EditorGalleria from "@/components/EditorGalleria.vue";
import EditorEmail from "@/components/EditorEmail.vue";
import SceltaTemplate from "@/components/SceltaTemplate.vue";
import VueFbCustomerChat from "vue-fb-customer-chat";
import Vue from "vue";
import { mapGetters } from "vuex";

console.log("chat messeger");

export default {
  components: {
    Soluzione,
    Editor,
    EditorGalleria,
    SceltaTemplate,
    EditorEmail
  },
  name: "HelloWorld",
  props: ["idreservation"],
  methods: {
    SetTempateData() {
      //this.template_to_export = presente
      console.log(this.template_to_export);
    },

    caricatesti() {
      this.$store.dispatch("getTesti", "cli1").then(
        response => {
          console.log(response);
          this.testiagg = response.data;
        },
        error => {
          console.error(error);
        }
      );
    },
    salvatemplate() {
      this.$router.push({ path: "/admin/saveastemplate#" });
    },
    applytemplate() {
      this.sceglitemplate = !this.sceglitemplate;
    },
    invia() {
      alert("da inviare!");
    },
    add_text(item) {
      this.$store.dispatch("addTesto", item).then(
        response => {
          console.log(response);
        },
        error => {
          console.error(error);
        }
      );
    },
    del_text(item) {
      this.$store.dispatch("delTesto", item).then(
        response => {
          console.log(response);
        },
        error => {
          console.error(error);
        }
      );
    },
    seleziona(soluzione) {
      this.tab = `tab-${soluzione.id}`;
      console.log(this.tab);
    },
    conferma(soluzione) {
      
      const occ = {
        Comando: "AccettaSoluzionePreventivo",
        NumeroSoluzione: soluzione.id,
        GUIDPrenotazione:this.idreservation
      };
      this.$store.dispatch("APIRequestHR", occ).then(r=>{
          console.log("RISP",r)
          if(r.data.RISPOSTAOK==-1){
            alert("Preventivo Confermato. Grazie.");
          }
          
      })
    },
    carica_preventivo(idpreve) {
      this.loading = true;
      console.log("CARICO PRENVENTIVO", this.idreservation);
      const t = this.$route.query.t;

      this.$store
        .dispatch("getPreventivo", { idpreventivo: idpreve, template: t })
        .then(
          response => {
            console.log("LOG CARICO PRENVENTIVO", response);

            this.loading = false;
          },
          error => {
            console.error(error);
          }
        );
    },
    modifica(context, variable) {
      this.context = context;
      this.variabile = variable;
      console.log(variable);
      this.dialog = true;
    },
    setvalue() {
      console.log("dialog chiuso");
      this.$store.dispatch("updatePreventivo");
      this.dialog = false;
    },
    composemail(){
      this.admin = true;
      this.composingmail=!this.composingmail
    }
  },
  mounted() {
    Vue.use(VueFbCustomerChat, {
      page_id: this.$store.state.config.facebook_page_id, //  change 'null' to your Facebook Page ID,
      theme_color: "#333333", // theme color in HEX
      locale: "en_US" // default 'en_US'
    });

    Vue.use(Editor);
    this.carica_preventivo(this.idreservation);
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user"
    }),
    preventivo() {
      return this.$store.state.preventivo;
    },
    testi() {
      console.log(
        "testiagg",
        this.$store.state.strutture.data[this.$store.state.strutturacorrente]
          .info
      );
      return this.$store.state.strutture.data[
        this.$store.state.strutturacorrente
      ].info;
    }
  },
  data: () => ({
    composingmail: false,
    testomail: "testo da inviare via mail",
    menu_templates: false,
    dialog: false,
    loading: true,
    testiagg: [],
    fab: false,
    sceglitemplate: false,
    template_to_export: {
      nominativo: null,
      intro: null,
      testoiniziale: null,
      titolo: null,
      sottotitolo: null
    },

    tab: null,
    admin: false,
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    icons: false,
    centered: false,
    grow: false,
    vertical: false,
    prevIcon: false,
    nextIcon: false,
    right: false,
    tabs: 3,
    footer_icons: [
      "mdi-facebook",
      "mdi-twitter",
      "mdi-google-plus",
      "mdi-linkedin",
      "mdi-instagram"
    ]
  })
};
</script>
